export default __webpack_public_path__ + "images/0x64875aaa68d1d5521666c67d692ee0b926b08b2f.png";